<template>
  <div class="weijiekongdan">
    <el-scrollbar id="menuWarpper"
                  style="height:calc(100%);">
      <el-main>
        <div class="header"
             ref="header">
          <div class="headerTop">
            <div class="header-con">
              <div class="header-con-form">
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">客户名称:</div>
                  <el-input v-model="kehumingcheng"
                            class="form-item-inputcpx"
                            placeholder="请输入"
                            @keyup.enter.native="ChaXun(1)">
                  </el-input>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">工单编号:</div>
                  <el-input v-model="gongdanCode"
                            class="form-item-inputcpx"
                            placeholder="请输入"
                            @keyup.enter.native="ChaXun(1)"
                            clearable>
                  </el-input>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">问题描述:</div>
                  <el-input v-model="describeWTMS"
                            class="form-item-inputcpx"
                            placeholder="请输入"
                            @keyup.enter.native="ChaXun(1)"
                            clearable>
                  </el-input>
                </div>

                <div class="header-con-form-item">
                  <div class="sousuomingcheng">起始日期:</div>
                  <el-date-picker v-model="kaishishijian"
                                  class="form-item-inputcpx"
                                  :clearable="false"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">终止日期:</div>
                  <el-date-picker v-model="jieshushijian"
                                  class="form-item-inputcpx"
                                  :clearable="false"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">客服:</div>
                  <el-input v-model="kefu"
                            class="form-item-inputcpx"
                            placeholder="请输入"
                            @keyup.enter.native="ChaXun(1)">
                  </el-input>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">产品线:</div>
                  <!-- <el-select class="form-item-inputcpx" v-model="chanpinxian" filterable clearable
										placeholder="输入关键词搜索" :filter-method="bindSelectChange"
										@change="dianjichanpinxian" popper-class="eloption"
										:popper-append-to-body="false">
										<el-option v-for="item in staff" :key="item.Code" :label="item.Name"
											:value="item.Code">
										</el-option>
									</el-select> -->
                  <el-select v-model="chanpinxian"
                             class="form-item-inputcpx"
                             placeholder="请选择"
                             clearable
                             multiple
                             transfer="true"
                             size="small"
                             style="width: 180px;"
                             @change="dianjichanpinxian"
                             popper-class="eloption">
                    <el-option v-for="item in staff"
                               :key="item.Code"
                               :label="item.Name"
                               :value="item.Code" />
                  </el-select>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">工单状态:</div>
                  <el-select v-model="gongdanzhuangtai"
                             class="form-item-inputcpx"
                             placeholder="请选择"
                             multiple
                             @change="dianzhuangtai"
                             clearable>
                    <el-option v-for="item in gongdanzhuangtaiList"
                               :key="item.Code"
                               :label="item.Name"
                               :value="item.Code">
                    </el-option>
                  </el-select>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">
                    问题类型
                  </div>
                  <el-select v-model="wentileixing"
                             class="form-item-inputcpx"
                             filterable
                             clearable
                             placeholder="请选择">
                    <el-option v-for="item in WenTileixingList"
                               :key="item.Code"
                               :label="item.Name"
                               :value="item.Code">
                    </el-option>
                  </el-select>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">预计完成日期:</div>
                  <el-date-picker v-model="JTjieshushijian"
                                  class="form-item-inputcpx"
                                  :clearable="true"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="预计完成日期"
                                  end-placeholder="预计完成日期">
                  </el-date-picker>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">完成开始日期:</div>
                  <el-date-picker v-model="WanChengshijianKS"
                                  class="form-item-inputcpx"
                                  :clearable="true"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="工单完成开始日期"
                                  end-placeholder="工单完成开始日期">
                  </el-date-picker>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">完成截止日期:</div>
                  <el-date-picker v-model="WanChengshijianJS"
                                  class="form-item-inputcpx"
                                  :clearable="true"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="工单完成截止日期"
                                  end-placeholder="工单完成截止日期">
                  </el-date-picker>
                </div>
                <!-- <div class="header-con-form-item">
									<div class="sousuomingcheng">完成工单时间:</div>

									<el-date-picker v-model="WanChengshijian" type="daterange" align="right"
										unlink-panels range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期" value-format="yyyy-MM-dd"
										:picker-options="pickerOptions">
									</el-date-picker>
								</div> -->

                <!-- <el-button class="anniuclass" type="success" @click="ChaXun(1)" :disabled="isChaXun">查询
								</el-button> -->
                <el-button class="anniuclass"
                           type="success"
                           @click="QBGDCX(1)"
                           :disabled="isChaXun">查询
                </el-button>
                <!-- 	<el-button class="anniuclass" type="warning" @click="SJSXChaXun(1)"
									:disabled="isChaXun">根据预计完成时间查询
								</el-button> -->
                <el-button class="anniuclass"
                           type="primary"
                           @click="daochuwendang">导出当前当前页</el-button>
                <!-- <el-button class="anniuclass" type="primary" @click="xinjianGongDan()">新建工单</el-button> -->
              </div>

            </div>

          </div>
        </div>
        <div class="maina"
             v-bind:style="{height:EchartsHeight}">
          <el-table v-loading="loading"
                    :cell-style="tableRowStyleName"
                    id="out-table"
                    ref="tableData"
                    :data="tableDataXS"
                    height="100%"
                    highlight-current-row
                    resizable
                    stripe
                    border
                    @row-dblclick="shuangjiChaKan">
            <el-table-column align="center"
                             type="index"
                             label="序号"
                             width="50"
                             show-overflow-tooltip>
              <template slot-scope="scope">

                <div style="background-color: crimson;"
                     v-if="SCXZ==scope.$index+1">{{scope.$index+1}}
                </div>
                <div v-else>{{scope.$index+1}}</div>

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="INFO_STATUS1"
                             label="状态"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="CUSTOMER_NAME"
                             label="客户名称"
                             min-width="180">
              <template slot-scope="scope">
                <div style="display: inline-block;vertical-align: bottom;">
                  <img v-if="scope.row.SLEVEL=='S'"
                       style="width: 20px;height: 20px;"
                       src="../../assets/img/tupianbaiS.png">
                  <img v-if="scope.row.SLEVEL=='A'"
                       style="width: 20px;height: 20px;"
                       src="../../assets/img/tupianbaiA.png">
                  <img v-if="scope.row.SLEVEL=='B'"
                       style="width: 20px;height: 20px;"
                       src="../../assets/img/tupianbaiB.png">
                  <img v-if="scope.row.SLEVEL=='C'"
                       style="width: 20px;height: 20px;"
                       src="../../assets/img/tupianbaiC.png">
                  <img v-if="scope.row.SLEVEL=='D'"
                       style="width: 20px;height: 20px;"
                       src="../../assets/img/tupianbaiD.png">
                </div>

                <div style="display: inline-block;height: 28px;">{{scope.row.CUSTOMER_NAME}}</div>

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="DESCRIBE"
                             label="留言"
                             width="100px"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="SPONSOR_NAME"
                             label="发起人"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="LAUNCH_TIME"
                             label="发起日期"
                             width="150"
                             show-overflow-tooltip>
              <template v-if="scope.row.LAUNCH_TIME!=null"
                        slot-scope="scope">
                {{scope.row.LAUNCH_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="CUSTOMER_SERVICE_NAME"
                             label="接单人"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="ESTIMATED_TIME"
                             label="预计完成时间"
                             width="190"
                             show-overflow-tooltip>
              <template v-if="scope.row.ESTIMATED_TIME!=null"
                        slot-scope="scope">
                {{scope.row.ESTIMATED_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="INFO_LEVEL"
                             label="难度等级"
                             width="190"
                             show-overflow-tooltip>
              <template v-if="scope.row.INFO_LEVEL!=null"
                        slot-scope="scope">
                {{scope.row.INFO_LEVEL}}

              </template>
            </el-table-column>

            <el-table-column align="center"
                             prop="RECIVE_TIME"
                             label="接单日期"
                             width="150"
                             show-overflow-tooltip>
              <template v-if="scope.row.RECIVE_TIME!=null"
                        slot-scope="scope">
                {{scope.row.RECIVE_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="PRODUCT_LINE1"
                             label="产品线"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="CONTACTS"
                             label="客户联系人"
                             width="100"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="CONTACT_INFORMATION"
                             label="客户联系方式"
                             width="150"
                             show-overflow-tooltip>
            </el-table-column>

            <el-table-column align="center"
                             prop="CODE"
                             label="工单号"
                             width="150"
                             show-overflow-tooltip>
            </el-table-column>

            <el-table-column align="center"
                             prop="INFO_TYPE1"
                             label="类型"
                             show-overflow-tooltip>
            </el-table-column>

            <el-table-column align="center"
                             prop="JOB_NUMBER"
                             label="客服工号"
                             show-overflow-tooltip>
            </el-table-column>

            <el-table-column align="center"
                             prop="HANDLE_TIME"
                             label="处理完成时间"
                             width="150"
                             show-overflow-tooltip>
              <template v-if="scope.row.HANDLE_TIME!=null"
                        slot-scope="scope">
                {{scope.row.HANDLE_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="Spend_TimeStr"
                             label="处理时长"
                             width="150"
                             show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column align="center" prop="SPEND_TIME" label="处理时长/小时" width="150"
							show-overflow-tooltip>
							<template v-if="scope.row.SPEND_TIME!=null" slot-scope="scope">
								{{scope.row.SPEND_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

							</template>
						</el-table-column> -->
            <el-table-column align="center"
                             prop="TERMINATE_TIME"
                             label="工单完成时间"
                             width="150"
                             show-overflow-tooltip>
              <template v-if="scope.row.TERMINATE_TIME!=null"
                        slot-scope="scope">
                {{scope.row.TERMINATE_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="SERVICE_STAR" label="评价星级" width="250px">
							<template slot-scope="scope">

								<p v-if="scope.row.pingjiazhangtai=='已评价'">
									已评价
									<el-rate ref="lb" class="liebiao" v-model="scope.row.SERVICE_STAR" :colors="colors"
										disabled>
									</el-rate>

								</p>
								<p v-if="scope.row.pingjiazhangtai=='待评价'">
									待评价
								</p>

							</template>
						</el-table-column> -->
            <el-table-column align="center"
                             prop="SERVICE_STAR"
                             label="评价星级"
                             width="250px">
              <template slot-scope="scope">

                <p v-if="scope.row.pingjiazhangtai=='已评价'">
                  已评价
                  <el-rate ref="lb"
                           class="liebiao"
                           v-model="scope.row.SERVICE_STAR"
                           :colors="colors"
                           disabled>
                  </el-rate>

                </p>
                <p v-if="scope.row.pingjiazhangtai=='待评价'">
                  待评价
                </p>

              </template>
            </el-table-column>
            <el-table-column v-if="xianshi==false"
                             align="center"
                             label="操作"
                             fixed="right"
                             width="150px">
              <template slot-scope="scope">
                <el-button type="primary"
                           @click="viewDoc(scope)">查看</el-button>

              </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="footer"
             ref="footer">
          <pagination :allPage="allPage"
                      :page-sizes="[100,300,500,1000,5000]"
                      :pageSize="pageSize"
                      :currIndex="currPage"
                      @hanSiChange="hanSiChange"
                      @hanCurrChange="hanCurrChange"></pagination>
        </div>
      </el-main>
    </el-scrollbar>

  </div>
</template>

<script>
import PinyinMatch from "pinyin-match";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  name: "quanbugongdanchaxun",
  data () {
    return {
      describeWTMS: "",
      SCXZ: "",
      Nowscroll: 0,
      gongdanCode: "",
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dormitory: [],
      xianshi: false,
      colors: ['#FF8C00', '#FF8C00', '#FF8C00', '#FF8C00', '#FF8C00'],
      isChaXun: false,
      kehumingcheng: '',
      dangqiandanhao: "",
      jdxzyjwcsj: false,
      EchartsHeight: (document.body.clientHeight - 220) + 'px',
      wentileixing: "",
      WenTileixingList: [],
      staffcopy: [],
      staff: [], //产品线
      staffz: [], //产品线
      chanpinxian: "", //产品线
      kaishishijian: "",
      jieshushijian: "",
      loading: false,
      WanChengshijian: "",
      WanChengshijianKS: "",
      WanChengshijianJS: "",
      currPage: 1,
      pageSize: 50,
      allPage: 0,
      yjwcallPage: 0,
      XMkaishishijian: "2022-03-01",
      JTjieshushijian: "",
      gongdanzhuangtai: "",
      gongdanzhuangtaiList: [{
        Code: "0",
        Name: "已撤销",
      },
      {
        Code: "1",
        Name: "已发起",
      },
      {
        Code: "2",
        Name: "已接单",
      },
      {
        Code: "3",
        Name: "已处理",
      },
      {
        Code: "4",
        Name: "已驳回",
      },
      {
        Code: "5",
        Name: "已完成",
      },

      ],
      tableData: [],
      tableDataXS: [],
      SXtableData: [],
      kefu: "",


    };
  },

  mounted () {
    this.SCXZ = "";
    const that = this;
    window.onresize = () => {
      // return (() => {
      window.screenHeight = document.body.clientHeight
      that.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
        .footer.offsetHeight - 70) + 'px'
      if (this.$refs.tableData && this.$refs.tableData.doLayout) {
        this.$refs.tableData.doLayout();
      }
      // })()
    }
    this.getPerson()
    this.getWenTileixing()
    this.addDate();
    this.currPage = 1;
    // this.ChaXun(this.currPage);
    this.QBGDCX(this.currPage)
    // this.SJSXChaXun()

  },
  activated () {
    const that = this;

    window.onresize = () => {
      // return (() => {

      window.screenHeight = document.body.clientHeight

      that.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
        .footer.offsetHeight - 70) + 'px'
      // if (this.$refs.tableData && this.$refs.tableData.doLayout) {
      // 		this.$refs.tableData.doLayout();
      // 	}
      // })()
    }

    setTimeout(() => {
      this.$refs.tableData.bodyWrapper.scrollTop = this.Nowscroll
    }, 13)

    // this.QBGDCX(this.currPage)
    // this.getPerson()
    // this.getWenTileixing()
    // this.addDate();
    // this.currPage = 1;
    // this.ChaXun(this.currPage);
  },
  // beforeRouteEnter(to, form, next) {
  // 	next(vm => {

  // 		vm.ChaXun(1)

  // 	})

  // },
  updated () {
    // myTable是表格的ref属性值
    if (this.$refs.tableData && this.$refs.tableData.doLayout) {
      this.$refs.tableData.doLayout();
    }
  },
  methods: {
    tableRowStyleName ({
      row
    }) {

      if (row.beijingse == 'huang') {
        return 'background-color: #FF9D00 !important;color:#ffffff';
      }

      if (row.beijingse == 'hong') {
        return 'background-color: #FF3A3A !important;color:#ffffff';
      }
      if (row.beijingse == 'hei') {
        return 'background-color: #ffffff !important;color:#000000';
      }
    },

    // tableRowClassName({row}){
    // 	console.log("tableRowClassName",row)
    // },
    doHandleMonth (month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    getDayCR (day, crday) {

      var today = new Date(crday);
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds);

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      var tHours = today.getHours();
      var tMinutes = today.getMinutes();
      var tSeconds = today.getSeconds();

      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      tHours = this.doHandleMonth(tHours);
      tMinutes = this.doHandleMonth(tMinutes);
      tSeconds = this.doHandleMonth(tSeconds);
      return tYear + "-" + tMonth + "-" + tDate + " " + tHours + ":" + tMinutes + ":" + tSeconds;
    },
    compare (date1, date2) {
      console.log("开始", date1, '结束', date2)
      let dates1 = new Date(date1);
      let dates2 = new Date(date2);
      if (dates1 > dates2) {
        return true
      } else {
        return false
      }
    },
    currentTime () {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth();
      console.log("month", month);
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ];
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = "0" + dateArr[i];
        }
      }
      var strDate =
        year +
        "-" +
        dateArr[0] +
        "-" +
        dateArr[1] +
        " " +
        dateArr[2] +
        ":" +
        dateArr[3] +
        ":" +
        dateArr[4];
      //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
      //this.date = strDate;
      // console.log("strDate", strDate);
      return strDate;
    },
    QBGDCX (index) {
      // if (this.JTjieshushijian == null || this.JTjieshushijian == "" || this.JTjieshushijian == undefined) {
      this.ChaXun(index)
      // } else {
      // 	this.SJSXChaXun(index)
      // }

    },
    daochuwendang () {
      this.xianshi = true;
      setTimeout(() => { //设置延迟执行
        this.exportExcel()
      }, 1000);

    },
    exportExcel () { //执行此方法导出Excel表格
      // 为el-table添加一个id：out-table
      // 当el-table使用了fixed时会导出两次数据，所以要先进行判断

      var fix = document.querySelector('.el-table__fixed');
      var wb;
      if (fix) {
        // 如果有fixed，先移除，然后再添加上
        wb = XLSX.utils.table_to_book(document.querySelector("#out-table").removeChild(fix))
        document.querySelector("#out-table").appendChild(fix)
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector("#out-table"))
      }
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream"
          }),
          // 导出的文件名称
          "全部工单查询" + new Date() + ".xlsx"
        )
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      setTimeout(() => { //设置延迟执行
        this.xianshi = false;
      }, 1000);

      return wbout;
    },

    dianzhuangtai () {
      this.currPage = 1;
      // this.ChaXun(this.currPage)
      // this.SJSXChaXun()
      this.QBGDCX(this.currPage)
    },
    dianjichanpinxian () {
      this.staff = this.staffz;
      this.currPage = 1;
      // this.ChaXun(this.currPage)
      // this.SJSXChaXun()
      this.QBGDCX(this.currPage)
    },
    bindSelectChange (val) {
      if (val) {
        this.staff = this.staffcopy.filter((item) => {
          return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
        })
      } else {
        this.staff = this.staffcopy
      }
    },
    //双击查看工单
    shuangjiChaKan (row) {
      this.SCXZ = row.$index + 1;
      let vmEl = this.$refs['tableData'].$el
      const scrollParent = vmEl.querySelector('.el-table__body-wrapper')
      this.Nowscroll = scrollParent.scrollTop
      console.log("this.Nowscroll", this.Nowscroll)
      this.$router.push({
        path: "quanbugongdanxq",
        query: {
          zhuangtai: 'N',
          qianyiyemingcheng: '全部工单查询',
          code: row.CODE,
          qianyiyemianglujing: "/home/quanbugongdanchaxun"
        }
      });


    },
    /**获取类型*/
    getWenTileixing () {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetGdLx",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == '0' || res.Code == 0) {
            this.WenTileixingList = res.Data;
          }

        })
        .catch((err) => {
          this.loading = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },

    //时间筛选用到的查询
    SJSXChaXun () {
      console.log("JTjieshushijian", this.JTjieshushijian)
      this.currPage = 1;
      this.loading = true;
      this.isChaXun = true;
      window.localStorage.setItem('qbgdstartDate', this.kaishishijian)
      window.localStorage.setItem('qbgdendDate', this.jieshushijian)
      if (this.gongdanzhuangtai == "") {
        this.$request({
          method: "GET",
          url: 'Info/GetReciveInfoList?customname=' + encodeURIComponent(this.kehumingcheng) +
            "&infoType=" + encodeURIComponent(this.wentileixing) +
            "&startDate=" +
            encodeURIComponent(
              this.kaishishijian + " 00:00:00") + "&endDate=" + encodeURIComponent(this
                .jieshushijian + " 23:59:59") + "&code=" + encodeURIComponent(this.gongdanCode) +
            "&chanpx=" + encodeURIComponent(this.chanpinxian) + "&sponsor=" + encodeURIComponent(
              this.kefu) + "&describe=" + encodeURIComponent(
                this.describeWTMS) + "&pageIndex=" + encodeURIComponent(this.currPage) + "&pageSize=" +
            encodeURIComponent(this.pageSize),
        })
          .then((res) => {
            // this.isChaXun = false;
            // this.loading = false;
            if (res.Code == '0' || res.Code == 0) {
              this.yjwcallPage = res.Total
            }


            this.SJSXChaXuntwo()
            // this.exportExcel()
          })
          .catch((err) => {
            this.isChaXun = false;
            this.loading = false;
            if (err == "Error: Request failed with status code 401") {
              this.$router.push({
                path: "/login",
              });
            }
          });
      } else {
        console.log("this.gongdanzhuangtai", this.gongdanzhuangtai)
        var wosStatus = "";
        for (var gongdanzhuangtaii = 0; gongdanzhuangtaii < this.gongdanzhuangtai
          .length; gongdanzhuangtaii++) {
          wosStatus = wosStatus + "&wosStatus=" + this.gongdanzhuangtai[gongdanzhuangtaii]
        }
        console.log(wosStatus)
        // + "&wosStatus=" + encodeURIComponent(
        // 	this
        // 	.gongdanzhuangtai)
        this.$request({
          method: "GET",
          url: 'Info/GetReciveInfoList?customname=' + encodeURIComponent(this.kehumingcheng) +
            "&infoType=" + encodeURIComponent(this.wentileixing) +
            "&startDate=" +
            encodeURIComponent(
              this.kaishishijian + " 00:00:00") + "&endDate=" + encodeURIComponent(this
                .jieshushijian + " 23:59:59") + "&code=" + encodeURIComponent(this.gongdanCode) +
            "&chanpx=" + encodeURIComponent(this.chanpinxian) + "&sponsor=" + encodeURIComponent(
              this.kefu) + "&describe=" + encodeURIComponent(
                this.describeWTMS) + "&pageIndex=" +
            encodeURIComponent(this.currPage) + "&pageSize=" + encodeURIComponent(this.pageSize) +
            wosStatus,
        })
          .then((res) => {
            // this.isChaXun = false;
            // this.loading = false;
            if (res.Code == '0' || res.Code == 0) {
              this.yjwcallPage = res.Total
            }
            this.SJSXChaXuntwo()


          })
          .catch((err) => {
            this.isChaXun = false;
            this.loading = false;
            if (err == "Error: Request failed with status code 401") {
              this.$router.push({
                path: "/login",
              });
            }
          });
      }


    },
    //时间筛选用到的查询
    SJSXChaXuntwo () {
      // this.loading = true;
      // this.isChaXun = true;
      window.localStorage.setItem('qbgdstartDate', this.kaishishijian)
      window.localStorage.setItem('qbgdendDate', this.jieshushijian)
      if (this.gongdanzhuangtai == "") {
        this.$request({
          method: "GET",
          url: 'Info/GetReciveInfoList?customname=' + encodeURIComponent(this.kehumingcheng) +
            "&infoType=" + encodeURIComponent(this.wentileixing) +
            "&startDate=" +
            encodeURIComponent(
              this.kaishishijian + " 00:00:00") + "&endDate=" + encodeURIComponent(this
                .jieshushijian + " 23:59:59") + "&code=" + encodeURIComponent(this.gongdanCode) +
            "&chanpx=" + encodeURIComponent(this.chanpinxian) + "&sponsor=" + encodeURIComponent(
              this.kefu) + "&describe=" + encodeURIComponent(
                this.describeWTMS) + "&pageIndex=" + encodeURIComponent(this.currPage) + "&pageSize=" +
            encodeURIComponent(this.yjwcallPage + 100),
        })
          .then((res) => {
            this.isChaXun = false;
            this.loading = false;
            if (res.Code == '0' || res.Code == 0) {
              this.SXtableData = res.Data;
            }

            this.dormitory = this.SXtableData.filter((item) => {
              //筛选后得到的数据 item 中包含数据日期 date
              //创建一个数组 date，存储得到的item.date

              let date = new Date(item.ESTIMATED_TIME);
              let time = date.getTime();
              return time >= this.XMkaishishijian + "T00:00:00" && time <= this
                .JTjieshushijian + "T23:59:59";
            });
            console.log("this.dormitory", this.dormitory)
            const dataTable = this.SXtableData.filter((dataTable) => {
              return new Date(dataTable.ESTIMATED_TIME) >= new Date(this.XMkaishishijian +
                "T00:00:00") && new Date(dataTable.ESTIMATED_TIME) <=
                new Date(this
                  .JTjieshushijian + "T23:59:59");
              //大于等于开始日期或者小于等于结束日期
            });
            console.log('dataTable:', dataTable, dataTable.length);
            this.tableData = dataTable;
            if (this.tableData.length > 0) {
              for (var i in this.tableData) {
                this.$set(this.tableData[i], 'beijingse', "hei");
                if (this.tableData[i].INFO_STATUS == 2) {

                  var liushitianqian = this.getDayCR(7, this.tableData[i].RECIVE_TIME);
                  var liushitianqiancgs = this.getDayCR(4, this.tableData[i].RECIVE_TIME);
                  var liushitianqianxqcq = this.getDayCR(14, this.tableData[i].RECIVE_TIME);
                  if (this.tableData[i].INFO_TYPE == 201) {
                    if (this.compare(this.currentTime(), liushitianqiancgs)) {

                      this.$set(this.tableData[i], 'beijingse', "huang");
                    }
                    if (this.compare(this.currentTime(), liushitianqian)) {

                      this.$set(this.tableData[i], 'beijingse', "hong");
                    }
                  } else {
                    if (this.compare(this.currentTime(), liushitianqiancgs)) {

                      this.$set(this.tableData[i], 'beijingse', "huang");
                    }
                    if (this.compare(this.currentTime(), liushitianqianxqcq)) {

                      this.$set(this.tableData[i], 'beijingse', "hong");
                    }
                  }

                }
                if (this.tableData[i].INFO_STATUS == 0) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已撤销')
                } else if (this.tableData[i].INFO_STATUS == 1) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已发起')
                } else if (this.tableData[i].INFO_STATUS == 2) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已接单')
                } else if (this.tableData[i].INFO_STATUS == 3) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已处理')
                } else if (this.tableData[i].INFO_STATUS == 4) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已驳回')
                } else if (this.tableData[i].INFO_STATUS == 5) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已完成')
                }
                if (this.tableData[i].SERVICE_STAR == 1 || this.tableData[i].SERVICE_STAR == 2 ||
                  this.tableData[i].SERVICE_STAR == 3 || this.tableData[i].SERVICE_STAR == 4 ||
                  this.tableData[i].SERVICE_STAR == 5) {
                  this.$set(this.tableData[i], 'pingjiazhangtai', '已评价')
                } else {
                  this.$set(this.tableData[i], 'pingjiazhangtai', '待评价')
                }
                for (var j in this.staff) {
                  if (this.tableData[i].PRODUCT_LINE == this.staff[j].Code) {
                    this.$set(this.tableData[i], 'PRODUCT_LINE1', this.staff[j].Name)
                  }
                }
                if (this.tableData[i].SERVICE_STAR == 1 || this.tableData[i].SERVICE_STAR == 2 ||
                  this.tableData[i].SERVICE_STAR == 3 || this.tableData[i].SERVICE_STAR == 4 ||
                  this.tableData[i].SERVICE_STAR == 5) {
                  this.$set(this.tableData[i], 'pingjiazhangtai', '已评价')
                } else {
                  this.$set(this.tableData[i], 'pingjiazhangtai', '待评价')
                }
                for (var z in this.WenTileixingList) {
                  if (this.tableData[i].INFO_TYPE == this.WenTileixingList[z].Code) {
                    this.$set(this.tableData[i], 'INFO_TYPE1', this.WenTileixingList[z].Name)
                  }
                }


              }
            }
            this.allPage = this.tableData.length


            if (this.$refs.header.offsetHeight == 0) {
              // this.EchartsHeight = (document.body.clientHeight - 230) + 'px'
              this.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
                .footer.offsetHeight - 70) + 'px'
              this.EchartsHeightxjgd = (window.screenHeight - this.$refs.header.offsetHeight - this
                .$refs
                .footer.offsetHeight - 70) + 'px'
              this.scrollbarHeight = (window.screenHeight - this.$refs.header.offsetHeight - this
                .$refs
                .footer.offsetHeight - 70) + 'px'
            } else {
              // this.EchartsHeight = (document.body.clientHeight - this.$refs.header.offsetHeight -
              // 	130) + 'px'
              this.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
                .footer.offsetHeight - 70) + 'px'
              this.EchartsHeightxjgd = (window.screenHeight - this.$refs.header.offsetHeight - this
                .$refs
                .footer.offsetHeight - 70) + 'px'
              this.scrollbarHeight = (window.screenHeight - this.$refs.header.offsetHeight - this
                .$refs
                .footer.offsetHeight - 70) + 'px'

            }
            this.tableDataXS = this.tableData.slice((this.currPage - 1) * this.pageSize, this
              .currPage * this
                .pageSize);

          })
          .catch((err) => {
            this.isChaXun = false;
            this.loading = false;
            if (err == "Error: Request failed with status code 401") {
              this.$router.push({
                path: "/login",
              });
            }
          });
      } else {
        console.log("this.gongdanzhuangtai", this.gongdanzhuangtai)
        var wosStatus = "";
        for (var gongdanzhuangtaii = 0; gongdanzhuangtaii < this.gongdanzhuangtai
          .length; gongdanzhuangtaii++) {
          wosStatus = wosStatus + "&wosStatus=" + this.gongdanzhuangtai[gongdanzhuangtaii]
        }
        console.log(wosStatus)
        // + "&wosStatus=" + encodeURIComponent(
        // 	this
        // 	.gongdanzhuangtai)
        this.$request({
          method: "GET",
          url: 'Info/GetReciveInfoList?customname=' + encodeURIComponent(this.kehumingcheng) +
            "&infoType=" + encodeURIComponent(this.wentileixing) +
            "&startDate=" +
            encodeURIComponent(
              this.kaishishijian + " 00:00:00") + "&endDate=" + encodeURIComponent(this
                .jieshushijian + " 23:59:59") +
            "&chanpx=" + encodeURIComponent(this.chanpinxian) + "&code=" + encodeURIComponent(this
              .gongdanCode) + "&sponsor=" + encodeURIComponent(
                this.kefu) + "&describe=" + encodeURIComponent(
                  this.describeWTMS) + "&pageIndex=" +
            encodeURIComponent(this.currPage) + "&pageSize=" + encodeURIComponent(this
              .yjwcallPage) +
            wosStatus,
        })
          .then((res) => {
            this.isChaXun = false;
            this.loading = false;
            if (res.Code == '0' || res.Code == 0) {
              this.SXtableData = res.Data;
            }

            this.dormitory = this.SXtableData.filter((item) => {
              //筛选后得到的数据 item 中包含数据日期 date
              //创建一个数组 date，存储得到的item.date

              let date = new Date(item.ESTIMATED_TIME);
              let time = date.getTime();
              return time >= this.XMkaishishijian + "T00:00:00" && time <= this
                .JTjieshushijian + "T23:59:59";
            });
            console.log("this.dormitory", this.dormitory)
            const dataTable = this.SXtableData.filter((dataTable) => {
              return new Date(dataTable.ESTIMATED_TIME) >= new Date(this.XMkaishishijian +
                "T00:00:00") && new Date(dataTable.ESTIMATED_TIME) <=
                new Date(this
                  .JTjieshushijian + "T23:59:59");
              //大于等于开始日期或者小于等于结束日期
            });
            console.log('dataTable:', dataTable, dataTable.length);
            this.tableData = dataTable;
            if (this.tableData.length > 0) {
              for (var i in this.tableData) {
                this.$set(this.tableData[i], 'beijingse', "hei");
                if (this.tableData[i].INFO_STATUS == 2) {

                  var liushitianqian = this.getDayCR(7, this.tableData[i].RECIVE_TIME);
                  var liushitianqiancgs = this.getDayCR(4, this.tableData[i].RECIVE_TIME);
                  var liushitianqianxqcq = this.getDayCR(14, this.tableData[i].RECIVE_TIME);
                  if (this.tableData[i].INFO_TYPE == 201) {
                    if (this.compare(this.currentTime(), liushitianqiancgs)) {

                      this.$set(this.tableData[i], 'beijingse', "huang");
                    }
                    if (this.compare(this.currentTime(), liushitianqian)) {

                      this.$set(this.tableData[i], 'beijingse', "hong");
                    }
                  } else {
                    if (this.compare(this.currentTime(), liushitianqiancgs)) {

                      this.$set(this.tableData[i], 'beijingse', "huang");
                    }
                    if (this.compare(this.currentTime(), liushitianqianxqcq)) {

                      this.$set(this.tableData[i], 'beijingse', "hong");
                    }
                  }

                }
                if (this.tableData[i].INFO_STATUS == 0) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已撤销')
                } else if (this.tableData[i].INFO_STATUS == 1) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已发起')
                } else if (this.tableData[i].INFO_STATUS == 2) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已接单')
                } else if (this.tableData[i].INFO_STATUS == 3) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已处理')
                } else if (this.tableData[i].INFO_STATUS == 4) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已驳回')
                } else if (this.tableData[i].INFO_STATUS == 5) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已完成')
                }
                for (var j in this.staff) {
                  if (this.tableData[i].PRODUCT_LINE == this.staff[j].Code) {
                    this.$set(this.tableData[i], 'PRODUCT_LINE1', this.staff[j].Name)
                  }
                }
                if (this.tableData[i].SERVICE_STAR == 1 || this.tableData[i].SERVICE_STAR == 2 ||
                  this.tableData[i].SERVICE_STAR == 3 || this.tableData[i].SERVICE_STAR == 4 ||
                  this.tableData[i].SERVICE_STAR == 5) {
                  this.$set(this.tableData[i], 'pingjiazhangtai', '已评价')
                } else {
                  this.$set(this.tableData[i], 'pingjiazhangtai', '待评价')
                }
                for (var z in this.WenTileixingList) {
                  if (this.tableData[i].INFO_TYPE == this.WenTileixingList[z].Code) {
                    this.$set(this.tableData[i], 'INFO_TYPE1', this.WenTileixingList[z].Name)
                  }
                }


              }
            }
            this.allPage = this.tableData.length
            if (this.$refs.header.offsetHeight == 0) {
              // this.EchartsHeight = (document.body.clientHeight - 230) + 'px'
              this.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
                .footer.offsetHeight - 70) + 'px'
              this.EchartsHeightxjgd = (window.screenHeight - this.$refs.header.offsetHeight - this
                .$refs
                .footer.offsetHeight - 70) + 'px'
              this.scrollbarHeight = (window.screenHeight - this.$refs.header.offsetHeight - this
                .$refs
                .footer.offsetHeight - 70) + 'px'
            } else {
              // this.EchartsHeight = (document.body.clientHeight - this.$refs.header.offsetHeight -
              // 	130) + 'px'
              this.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
                .footer.offsetHeight - 70) + 'px'
              this.EchartsHeightxjgd = (window.screenHeight - this.$refs.header.offsetHeight - this
                .$refs
                .footer.offsetHeight - 70) + 'px'
              this.scrollbarHeight = (window.screenHeight - this.$refs.header.offsetHeight - this
                .$refs
                .footer.offsetHeight - 70) + 'px'

            }
            this.tableDataXS = this.tableData.slice((this.currPage - 1) * this.pageSize, this
              .currPage * this
                .pageSize);

          })
          .catch((err) => {
            this.isChaXun = false;
            this.loading = false;
            if (err == "Error: Request failed with status code 401") {
              this.$router.push({
                path: "/login",
              });
            }
          });
      }


    },
    //查询
    ChaXun (index) {
      console.log("ChaXun", index);
      // var gdwanchengkssj = ""
      // var gdwanchengjssj = ""
      // if (this.WanChengshijian != null || this.WanChengshijian != undefined || this.WanChengshijian != "") {
      // 	gdwanchengkssj = this.WanChengshijian[0]+" 00:00:00";
      // 	gdwanchengjssj = this.WanChengshijian[1]+" 23:59:59";
      // }
      var JTjieshushijianstr = ""
      if (this.JTjieshushijian == null || this.JTjieshushijian == undefined || this.JTjieshushijian == "") {
        JTjieshushijianstr = ""
      } else {
        JTjieshushijianstr = this.JTjieshushijian + " 23:59:59"
      }
      var WanChengshijianKSstr = ""
      if (this.WanChengshijianKS == null || this.WanChengshijianKS == undefined || this.WanChengshijianKS ==
        "") {
        WanChengshijianKSstr = ""
      } else {
        WanChengshijianKSstr = this.WanChengshijianKS + " 00:00:00"
      }
      var WanChengshijianJSstr = ""
      if (this.WanChengshijianJS == null || this.WanChengshijianJS == undefined || this.WanChengshijianJS ==
        "") {
        WanChengshijianJSstr = ""
      } else {
        WanChengshijianJSstr = this.WanChengshijianJS + " 23:59:59"
      }
      this.currPage = index;
      this.loading = true;
      this.isChaXun = true;
      window.localStorage.setItem('qbgdstartDate', this.kaishishijian)
      window.localStorage.setItem('qbgdendDate', this.jieshushijian)
      if (this.gongdanzhuangtai == "") {
        this.$request({
          method: "GET",
          url: 'Info/GetReciveInfoList?customname=' + encodeURIComponent(this.kehumingcheng) +
            "&infoType=" + encodeURIComponent(this.wentileixing) +
            "&startDate=" +
            encodeURIComponent(
              this.kaishishijian + " 00:00:00") + "&endDate=" + encodeURIComponent(this
                .jieshushijian + " 23:59:59") +
            "&chanpx=" + encodeURIComponent(this.chanpinxian) + "&code=" + encodeURIComponent(this
              .gongdanCode) + "&sponsor=" + encodeURIComponent(
                this.kefu) + "&describe=" + encodeURIComponent(
                  this.describeWTMS) + "&pageIndex=" + encodeURIComponent(index) + "&pageSize=" +
            encodeURIComponent(this.pageSize) +
            "&terminateStartDate=" +
            encodeURIComponent(
              WanChengshijianKSstr) + "&terminateEndDate=" + encodeURIComponent(
                WanChengshijianJSstr) + "&estimatedDate=" + encodeURIComponent(JTjieshushijianstr),
        })
          .then((res) => {
            this.isChaXun = false;
            this.loading = false;
            if (res.Code == '0' || res.Code == 0) {
              this.tableData = res.Data;
            }
            if (this.tableData.length > 0) {
              for (var i in this.tableData) {
                this.$set(this.tableData[i], 'beijingse', "hei");
                if (this.tableData[i].INFO_STATUS == 2) {

                  var liushitianqian = this.getDayCR(7, this.tableData[i].RECIVE_TIME);
                  var liushitianqiancgs = this.getDayCR(4, this.tableData[i].RECIVE_TIME);
                  var liushitianqianxqcq = this.getDayCR(14, this.tableData[i].RECIVE_TIME);
                  if (this.tableData[i].INFO_TYPE == 201) {
                    if (this.compare(this.currentTime(), liushitianqiancgs)) {

                      this.$set(this.tableData[i], 'beijingse', "huang");
                    }
                    if (this.compare(this.currentTime(), liushitianqian)) {

                      this.$set(this.tableData[i], 'beijingse', "hong");
                    }
                  } else {
                    if (this.compare(this.currentTime(), liushitianqiancgs)) {

                      this.$set(this.tableData[i], 'beijingse', "huang");
                    }
                    if (this.compare(this.currentTime(), liushitianqianxqcq)) {

                      this.$set(this.tableData[i], 'beijingse', "hong");
                    }
                  }

                }
                if (this.tableData[i].INFO_STATUS == 0) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已撤销')
                } else if (this.tableData[i].INFO_STATUS == 1) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已发起')
                } else if (this.tableData[i].INFO_STATUS == 2) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已接单')
                } else if (this.tableData[i].INFO_STATUS == 3) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已处理')
                } else if (this.tableData[i].INFO_STATUS == 4) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已驳回')
                } else if (this.tableData[i].INFO_STATUS == 5) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已完成')
                }
                for (var j in this.staff) {
                  if (this.tableData[i].PRODUCT_LINE == this.staff[j].Code) {
                    this.$set(this.tableData[i], 'PRODUCT_LINE1', this.staff[j].Name)
                  }
                }
                if (this.tableData[i].SERVICE_STAR == 1 || this.tableData[i].SERVICE_STAR == 2 ||
                  this.tableData[i].SERVICE_STAR == 3 || this.tableData[i].SERVICE_STAR == 4 ||
                  this.tableData[i].SERVICE_STAR == 5) {
                  this.$set(this.tableData[i], 'pingjiazhangtai', '已评价')
                } else {
                  this.$set(this.tableData[i], 'pingjiazhangtai', '待评价')
                }
                for (var z in this.WenTileixingList) {
                  if (this.tableData[i].INFO_TYPE == this.WenTileixingList[z].Code) {
                    this.$set(this.tableData[i], 'INFO_TYPE1', this.WenTileixingList[z].Name)
                  }
                }




              }
            }
            this.allPage = res.Total
            this.tableDataXS = this.tableData;
            if (this.$refs.header.offsetHeight == 0) {
              this.EchartsHeight = (document.body.clientHeight - 230) + 'px'

            } else {
              this.EchartsHeight = (document.body.clientHeight - this.$refs.header.offsetHeight -
                130) + 'px'

            }
            this.$nextTick(() => {
              // myTable是表格的ref属性值
              if (this.$refs.tableData && this.$refs.tableData.doLayout) {
                this.$refs.tableData.doLayout();
              }
            })
            console.log("this.Nowscroll", this.Nowscroll)
            setTimeout(() => {
              this.$refs.tableData.bodyWrapper.scrollTop = this.Nowscroll
            }, 13)

            // this.exportExcel()
          })
          .catch((err) => {
            this.isChaXun = false;
            this.loading = false;
            if (err == "Error: Request failed with status code 401") {
              this.$router.push({
                path: "/login",
              });
            }
          });
      } else {
        console.log("this.gongdanzhuangtai", this.gongdanzhuangtai)
        var wosStatus = "";
        for (var gongdanzhuangtaii = 0; gongdanzhuangtaii < this.gongdanzhuangtai
          .length; gongdanzhuangtaii++) {
          wosStatus = wosStatus + "&wosStatus=" + this.gongdanzhuangtai[gongdanzhuangtaii]
        }
        console.log(wosStatus)
        // + "&wosStatus=" + encodeURIComponent(
        // 	this
        // 	.gongdanzhuangtai)
        this.$request({
          method: "GET",
          url: 'Info/GetReciveInfoList?customname=' + encodeURIComponent(this.kehumingcheng) +
            "&infoType=" + encodeURIComponent(this.wentileixing) +
            "&startDate=" +
            encodeURIComponent(
              this.kaishishijian + " 00:00:00") + "&endDate=" + encodeURIComponent(this
                .jieshushijian + " 23:59:59") +
            "&chanpx=" + encodeURIComponent(this.chanpinxian) + "&code=" + encodeURIComponent(this
              .gongdanCode) + "&sponsor=" + encodeURIComponent(
                this.kefu) + "&describe=" + encodeURIComponent(
                  this.describeWTMS) + "&pageIndex=" +
            encodeURIComponent(index) + "&pageSize=" + encodeURIComponent(this.pageSize) +
            wosStatus +
            "&terminateStartDate=" +
            encodeURIComponent(
              WanChengshijianKSstr) + "&terminateEndDate=" + encodeURIComponent(
                WanChengshijianJSstr) + "&estimatedDate=" + encodeURIComponent(JTjieshushijianstr),
        })
          .then((res) => {
            console.log("res", res)
            this.isChaXun = false;
            this.loading = false;
            if (res.Code == '0' || res.Code == 0) {
              this.tableData = res.Data;
            }
            if (this.tableData.length > 0) {
              for (var i in this.tableData) {
                this.$set(this.tableData[i], 'beijingse', "hei");
                if (this.tableData[i].INFO_STATUS == 2) {

                  var liushitianqian = this.getDayCR(7, this.tableData[i].RECIVE_TIME);
                  var liushitianqiancgs = this.getDayCR(4, this.tableData[i].RECIVE_TIME);
                  var liushitianqianxqcq = this.getDayCR(14, this.tableData[i].RECIVE_TIME);
                  if (this.tableData[i].INFO_TYPE == 201) {
                    if (this.compare(this.currentTime(), liushitianqiancgs)) {

                      this.$set(this.tableData[i], 'beijingse', "huang");
                    }
                    if (this.compare(this.currentTime(), liushitianqian)) {

                      this.$set(this.tableData[i], 'beijingse', "hong");
                    }
                  } else {
                    if (this.compare(this.currentTime(), liushitianqiancgs)) {

                      this.$set(this.tableData[i], 'beijingse', "huang");
                    }
                    if (this.compare(this.currentTime(), liushitianqianxqcq)) {

                      this.$set(this.tableData[i], 'beijingse', "hong");
                    }
                  }

                }
                if (this.tableData[i].INFO_STATUS == 0) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已撤销')
                } else if (this.tableData[i].INFO_STATUS == 1) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已发起')
                } else if (this.tableData[i].INFO_STATUS == 2) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已接单')
                } else if (this.tableData[i].INFO_STATUS == 3) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已处理')
                } else if (this.tableData[i].INFO_STATUS == 4) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已驳回')
                } else if (this.tableData[i].INFO_STATUS == 5) {
                  this.$set(this.tableData[i], 'INFO_STATUS1', '已完成')
                }
                if (this.tableData[i].SERVICE_STAR == 1 || this.tableData[i].SERVICE_STAR == 2 ||
                  this.tableData[i].SERVICE_STAR == 3 || this.tableData[i].SERVICE_STAR == 4 ||
                  this.tableData[i].SERVICE_STAR == 5) {
                  this.$set(this.tableData[i], 'pingjiazhangtai', '已评价')
                } else {
                  this.$set(this.tableData[i], 'pingjiazhangtai', '待评价')
                }
                for (var j in this.staff) {
                  if (this.tableData[i].PRODUCT_LINE == this.staff[j].Code) {
                    this.$set(this.tableData[i], 'PRODUCT_LINE1', this.staff[j].Name)
                  }
                }
                for (var z in this.WenTileixingList) {
                  if (this.tableData[i].INFO_TYPE == this.WenTileixingList[z].Code) {
                    this.$set(this.tableData[i], 'INFO_TYPE1', this.WenTileixingList[z].Name)
                  }
                }


              }
            }
            this.allPage = res.Total
            this.tableDataXS = this.tableData;
            if (this.$refs.header.offsetHeight == 0) {
              this.EchartsHeight = (document.body.clientHeight - 260) + 'px'

            } else {
              this.EchartsHeight = (document.body.clientHeight - this.$refs.header.offsetHeight -
                130) + 'px'

            }
            this.$nextTick(() => {
              // myTable是表格的ref属性值
              if (this.$refs.tableData && this.$refs.tableData.doLayout) {
                this.$refs.tableData.doLayout();
              }
            })

            setTimeout(() => {
              this.$refs.tableData.bodyWrapper.scrollTop = this.Nowscroll
            }, 13)


          })
          .catch((err) => {
            this.isChaXun = false;
            this.loading = false;
            if (err == "Error: Request failed with status code 401") {
              this.$router.push({
                path: "/login",
              });
            }
          });
      }


    },
    /**获取产品线 */
    getPerson () {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetProducts",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == '0' || res.Code == 0) {
            var arr = [];

            // var bdcpx = JSON.parse(localStorage.getItem("userInfo")).PRODUCT_LINE.split(',');

            for (var i in res.Data) {
              // for (var j in bdcpx) {

              // if (res.Data[i].Code == bdcpx[j]) {
              arr.push(res.Data[i])
              // }

              // }

            }
            this.staff = arr;
            this.staffz = arr;
            this.staffcopy = this.staff;
          }


        })
        .catch((err) => {
          this.loading = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },

    /**查看 */
    viewDoc (row) {
      this.SCXZ = row.$index + 1;
      let vmEl = this.$refs['tableData'].$el
      const scrollParent = vmEl.querySelector('.el-table__body-wrapper')
      this.Nowscroll = scrollParent.scrollTop
      // console.log("this.Nowscroll", this.Nowscroll)
      this.$router.push({
        path: "quanbugongdanxq",
        query: {
          zhuangtai: 'N',
          qianyiyemingcheng: '全部工单查询',
          code: row.row.CODE,
          qianyiyemianglujing: "/home/quanbugongdanchaxun"
        }
      });
    },
    addDate () {
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };

      if (date.month < 10) {
        date.month = '0' + date.month; //补齐
      }
      if (date.date < 10) {
        date.date = '0' + date.date; //补齐
      }
      // let shijianshuzu = [];
      let shijian = date.year + "-" + date.month + "-" + date.date;

      // shijianshuzu.push(shijian);
      // shijianshuzu.push(shijian);
      this.kaishishijian = shijian;
      this.jieshushijian = shijian;
      if (window.localStorage.getItem('qbgdstartDate') != "null" && window.localStorage.getItem(
        'qbgdstartDate') != "") {
        this.kaishishijian = window.localStorage.getItem('qbgdstartDate');
        // this.jieshushijian = window.localStorage.getItem('qbgdendDate');
      }
      // this.JTjieshushijian = shijian

    },

    /**分页size改变 */
    hanSiChange (val) {
      this.pageSize = val;
      this.Nowscroll = 0;
      this.currPage = 1;
      this.SCXZ = "";
      // this.ChaXun(this.currPage);
      // if (this.JTjieshushijian == null || this.JTjieshushijian == "" || this.JTjieshushijian == undefined) {
      this.ChaXun(this.currPage)
      // } else {
      // 	this.tableDataXS = this.tableData.slice((this.currPage - 1) * this.pageSize, this.currPage * this
      // 		.pageSize);
      // }
    },
    /**当前页改变 */
    hanCurrChange (val) {
      this.currPage = val;
      this.Nowscroll = 0;
      this.SCXZ = "";
      // this.ChaXun(this.currPage);
      // if (this.JTjieshushijian == null || this.JTjieshushijian == "" || this.JTjieshushijian == undefined) {
      this.ChaXun(this.currPage)
      // } else {
      // 	this.tableDataXS = this.tableData.slice((this.currPage - 1) * this.pageSize, this.currPage * this
      // 		.pageSize);
      // }
    },





  },
};
</script>

<style scoped>
.warm-row {
  background-color: #f9f9f9 !important;
}

.weijiekongdan {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding: 20px; */
  padding-left: 0px;
  background-color: #f0f0f0;
}

.el-main {
  background-color: #f0f0f0;
  padding: 0px;
}

/* 头部选择模板名称 */
.header {
  height: auto;
  background-color: #ffffff;
  padding-left: 20px;
  padding-top: 20px;
  /* width: calc(100%-10px); */
}

.headerTop {
  display: flex;
  justify-content: space-between;
}

.header-con {
  height: auto;
  /* width: calc(100%-200px); */
  display: flex;
  align-items: center;
}

.header-con-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-wrap: break-word;
  overflow: hidden;
  margin: auto;
  /* 看自己需要设置，不影响div高度变化*/
}

.header-con-form-item {
  margin-bottom: 15px;
}

.list {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
}

.item {
  width: 100%;
  height: 100%;
}

.itema {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  height: 30px;
}

.itemb {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 0px;
  bottom: 0px;
}

.itemaBoxa {
  float: left;
  margin-top: 3px;
  margin-left: 0px;
  margin-left: 4px;
  width: 100px;
  height: 30px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxb {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 200px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxc {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 100px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemBox {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #ebeef5;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  height: 80px;
}

.itemBoxa {
  float: left;
  top: 20px;
  left: 0px;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxb {
  float: left;
  top: 20px;
  left: 20%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxc {
  float: left;
  top: 20px;
  left: 40%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxd {
  float: left;
  top: 20px;
  left: 60%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.anniuclass {
  margin-left: 20px;
  /* margin-top: 10px; */
  margin-bottom: 15px;
}

.itemTop {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  padding: 0 25px;
  /* border-bottom: 1px solid #F2F4F9; */
}

.itemTopText {
  float: left;
  width: 80px;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #000000;
  opacity: 1;
  margin-left: 10rpx;
}

.sousuoyou {
  float: right;
  margin-top: 20px;
  /* right: 30px; */
  margin-right: 20px;
  width: 92px;
  height: 36px;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  /* width: 100%;
  height: 100%; */
  overflow: hidden;
  /* background-color: #fff; */
}

.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* 主体容器 */
.main {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

/* 主体容器 */
.maina {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

.yemakuandu {
  width: 99%;
  background-color: #fff;
  height: 40px;
  padding-top: 20px;
}

/**输入框宽度 */
.input {
  width: 200px;
}

/**dialog中样式 */
.dialog-con {
  height: 375px;
  overflow: auto;
}

.itemc {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 10px;
  /* height: 98%; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemcBoxa {
  width: 49.95%;
  height: 70px;
  max-height: 100px;
  float: none;

  background-color: #fff;
}

.itemd {
  box-sizing: border-box;
  width: 100%;
  height: 98%;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemdtext {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 80%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

.itemdtexta {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 16%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

/**底部分页 */
.footer {
  height: 50px;
  margin-right: 0px;
}

/**输入框宽度 */
.form-item-inputcpx {
  width: 180px;
}

.containera {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  margin-top: -10px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.headerxjgd {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.headeraxjgd {
  margin-bottom: 2px;
}

.fanhuiBtnxjgd {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 20px;
  display: inline-block;
}

.liebiao {
  height: 40px;
}

/deep/.el-rate__icon {
  font-size: 38px;
}

/deep/ .iconyishoucang {
  color: #ffff00;
  font-size: 22px;
}

/deep/ .iconshoucang {
  color: #bbb;
  font-size: 22px;
}

.yonghuminglabexjgd {
  margin-top: 0px;
  margin-left: 90px;
  margin-bottom: 20px;
  display: inline-block;
}

/* 主体容器 */
.mainxjgd {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

/* 主体容器 */
.mainxjgda {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

.tijiaobtnxjgd {
  /* display: flex; */
  margin-top: 30px;
  margin-left: 50%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
}

.tijiaobtnxjgdza {
  /* display: flex; */
  margin-top: 30px;
  text-align: center;
  /* margin-left: 100px; */
  width: 50%;
  display: inline-block;
}

.tckmingcheng {
  width: 100%;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
  color: #333333;
}

.tckmingchenga {
  width: 100%;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
  color: #333333;
  margin-top: 30px;
}

.tijiaobtnxjgda {
  /* display: flex; */
  margin-top: 0px;
  margin-left: 40%;
  margin-bottom: 20px;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
  display: inline-block;
}

.tijiaobtnxjgdb {
  /* display: flex; */
  margin-top: 0px;
  margin-bottom: 20px;
  margin-right: 20%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
  display: inline-block;
}

.header-conxjgd {
  margin-left: 0px;
}

.header-conaxjgd {
  display: flex;
  align-items: center;
  height: 30px;
  margin-left: 30px;
}

.header-con-formxjgd {
  display: flex;
  align-items: center;
}

.sousuomingcheng {
  text-align: center;
  display: inline-block;
  margin-right: 10px;
  margin-left: 0px;
  font-size: 15px;
  font-weight: 400;
  width: 100px;
  text-align: right;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatarxjgd {
  width: 178px;
  height: 178px;
  display: block;
}

.el-card {
  box-shadow: 0 1px 1px #f5f5f5 !important;
}

/deep/.eloption .el-select-dropdown__wrap {
  max-height: 400px !important;
}

/deep/ .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

.el-table {
  overflow-y: auto !important;
  overflow-x: auto !important;
}

/* 	/deep/ .el-dialog {
		height: 80%;
	} */
</style>